import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';
import { PointVenteResponse } from '../../../model/response/PointVenteResponse';
import { PointVente } from '../../../model/PointVente';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OnePointVenteResponse } from '../../../model/response/OnePointVenteResponse';
import { EnvironmentService } from '../../environnement.service';

@Injectable({
  providedIn: 'root'
})
export class PointVenteEndPointService {

  constructor(private environmentService: EnvironmentService, private httpclient: HttpClient) { }

  header = new HttpHeaders(
    {
      'Access-Control-Allow-Origin': '*',
      'Content-type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT'
    }
  );

  CreatePointVente(pointVente: PointVente) {
    return this.httpclient.post<OnePointVenteResponse>(this.environmentService.backend_url_Pos + "CreatePointVente", pointVente, { headers: this.header });
  }

  findAllByIdPartenaireBprice(id: string) {
    return this.httpclient.get<PointVenteResponse>(this.environmentService.backend_url_Pos + "findAllByIdPartenaireBprice/" + id, { headers: this.header });
  }
  findPointVenteByIdPointVente(pointVenteId: string) {
    return this.httpclient.get<OnePointVenteResponse>(this.environmentService.backend_url_Pos + "findPointVenteByIdPointVente/" + pointVenteId, { headers: this.header });
  }

  /**
   * Upload facture partenaire for a point de vente.
   * File is stored under /var/www/html/adcaisse/factures/{point de vente designation}/facture-{date with PV timezone}.
   * result = 1: success, 0: upload failed, -1: Point de vente not found, -2: idPointVente or file missing.
   */
  uploadFacturePartenaire(idPointVente: string, file: File) {
    const formData = new FormData();
    formData.append('idPointVente', idPointVente);
    formData.append('file', file);
    return this.httpclient.post<{ result: number; errorDescription?: string }>(
      this.environmentService.backend_url_Admin + 'uploadFacturePartenaire',
      formData
    );
  }
}
